/* global axios */
import ApiClient from './ApiClient';

class NewsAPI extends ApiClient {
  constructor() {
    super('news', { accountScoped: true });
  }

  active() {
    return axios.get(`${this.url}/active`);
  }

  markViewed(id) {
    return axios.post(`${this.url}/${id}/view`);
  }

  markClicked(id) {
    return axios.patch(`${this.url}/${id}/click`);
  }
}

export default new NewsAPI();
